module.exports = __webpack_public_path__ + "static/media/carl.81bcf7f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Drone/carl.jpg
// module id = 302
// module chunks = 0